import {
  ActionIcon,
  ThemeIcon,
  Tooltip,
  rem,
  type TooltipProps,
} from '@mantine/core';
import type { MouseEventHandler } from 'react';
import InfoToolTipIcon from '@/assets/icons/info-tooltip-icon.svg';

type Props = Pick<TooltipProps, 'multiline' | 'maw' | 'label' | 'disabled'> & {
  className?: string;
  ariaLabel?: string | undefined;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};

export default function InfoTooltip({
  className,
  ariaLabel,
  onClick,
  ...props
}: Props) {
  return (
    <Tooltip {...props} className={className}>
      {onClick && typeof onClick === 'function' ? (
        <ActionIcon
          className="pointer-events-auto"
          onClick={onClick}
          variant="transparent"
          color="neutral.5"
          radius="xl"
          size={rem(18)}
          flex="none"
          aria-label={ariaLabel}
          styles={{
            root: { verticalAlign: 'middle' },
          }}
        >
          <InfoToolTipIcon size={16} />
        </ActionIcon>
      ) : (
        <ThemeIcon
          className="pointer-events-auto"
          variant="white"
          color="neutral.5"
          radius="xl"
          size={rem(18)}
          flex="none"
          aria-label={props['aria-label']}
          styles={{
            root: { verticalAlign: 'middle' },
          }}
        >
          <InfoToolTipIcon size={16} />
        </ThemeIcon>
      )}
    </Tooltip>
  );
}
